import { SkeletonBox } from '@practium/ui';
import styles from './BillingRevenueChart.module.css';

export const BillingRevenueChartSkeleton = () => (
	<>
		<div className={styles.info}>
			<div className={styles.skeletonValue}>
				<SkeletonBox width="100%" height="100%" />
			</div>
			<SkeletonBox width="7rem" height="0.8rem" />
		</div>
		<div className={`${styles.chartContainer} ${styles.skeletonArea}`}>
			<SkeletonBox width="100%" height="100%" borderRadius="0.75rem" />
		</div>
	</>
);
